import get from 'lodash/get';
import ApiCaller from 'fk-cp-shared/utils/MapiApiHelper';
import clientStore from '../clientStore';
import { is401Error } from './statusCodesUtil';
import PuppetConfig from '../mossad/PuppetConfig';
import NewRelicLogger, {
	getQueriesFromURL
}from './newRelicLoghelper';

export const _logger = new NewRelicLogger();

const getPhantomAjaxConfig = params => ({
	...params,
	ajaxConfig: {
		...params.ajaxConfig,
		hostname: window.location.hostname,
		port: window.location.port,
		overrideMapiEndpoint: true,
		headers: {
			...params.ajaxConfig.headers,
			'x-puppet-account': PuppetConfig.getAccountId(),
			'x-puppet-proxy': PuppetConfig.getApiProxy()
		}
	}
});

function ApiStoreInterface(store) {
	this.store = store;
	this.fetch = function(method, origParams, body) {
		const params = __PHANTOM__ ? getPhantomAjaxConfig(origParams) : origParams;
		return ApiCaller.fetch(method, params, body, _logger)
			.then(response => {
				const abWrapper = get(response, ['META_INFO', 'abContext', 'abWrapper']);
				if (abWrapper && abWrapper.length > 0) {
					this.store.dispatch({
						type: 'SET_ABV2_STATE',
						data: abWrapper
					});
				}
				if (response && get(origParams, ['ajaxConfig', 'app'])) {
					if(!!response ['SESSION']){
						const sessionData = response['SESSION'] || {}
						window.localStorage.setItem('userAccID',sessionData.accountId)
						if(_logger && typeof _logger.setUserAccountId === 'function'){
							_logger.setUserAccountId(sessionData.accountId)
						}
						this.store.dispatch({
							type: 'SET_USER_STATE',
							data: response['SESSION']
						});
					}
				}
				return response;
			})
			.catch(error => {
				const data = {
					accId: window.localStorage.getItem('userAccID'),
					apiUrl: origParams && origParams.ajaxConfig && origParams.ajaxConfig.pathname,
					apiRequestBody: body || {},
					apiResponseBody: error && error.body || {},
					apiErrorCode: error && error.status,
					apiErrorMessage: error && error.statusText					,
					origParamsDetails: origParams,
					urlDetails: getQueriesFromURL(),
					apiErrorDetails: error
				};
				_logger.logErrorEvent(
					data,
					"SS_API_ERROR"
				);
				const isThirdParty = ['blobio.flipkart.net'].includes(origParams.ajaxConfig.hostname);
				if (!isThirdParty && is401Error(error)) {
					this.store.dispatch({
						type: 'UNSET_USER_STATE'
					});
				}
				return Promise.reject(error);
			});
	};
}

ApiStoreInterface.prototype = Object.create(ApiCaller);
ApiStoreInterface.prototype.constructor = ApiStoreInterface;

export default new ApiStoreInterface(clientStore);
